export default {
  arribo: 'Arribo',
  global: {
    back: 'Regresar',
    next: 'Siguiente',
    continue: 'Continuar',
    logout: 'Cerrar sesión',
    from: 'desde',
    month: 'mes',
    finish: 'Finalizar',
    findYourRecommendation: 'Encuentra tu recomendación',
  },
  language: {
    es: 'Español',
    en: 'Inglés',
  },
  validations: {
    minLength: 'No puede ser menor a {min} carácteres',
    invalidFileSize: 'El archivo no puede ser mayor a {size}',
    uppercase: '1 mayúscula requerida',
    lowercase: '1 minúscula requerida',
    number: '1 número requerido',
    specialChar: '1 caracter especial requerido',
  },
  splash: {
    claim: 'Reclamar',
  },
  actions: {
    logoutText: '¿Está seguro? Está a punto de cerrar sesión',
    yesLogout: 'Si, cerrar sesión',
    createAccount: 'Crear cuenta',
    changeEmail: 'Cambiar email',
    changePassword: 'Cambiar password',
    recoveryPassword: 'Recuperar contraseña',
    discard: 'Descartar',
    saveEmail: 'Salvar email',
    resendCode: 'Reenviar código',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    sendEmail: 'Enviar email',
    saveChanges: 'Guardar cambios',
    upload: 'Subir',
    save: 'Guardar',
    recovery: 'Recuperar',
    complete: 'Completar',
    uploading: 'Subiendo ...',
    showAll: 'Mostrar todos',
    hideAll: 'Ocultar',
    signNow: 'Firmar ahora',
    add: 'Agregar',
    viewFile: 'Ver archivo',
    delete: 'Eliminar',
  },
  welcome: {
    createAccount: 'Crear cuenta',
    continueGuest: 'Continuar como invitado',
    haveAnAccount: 'Ya tengo una cuenta',
    goToWelcome: 'Inicio',
    inAllianceWith: 'En alianza con ',
  },
  login: {
    title: 'Ingresar a su cuenta',
    passwordRecovery: 'Recuperar contraseña',
    notAccount: 'No tengo una cuenta todavía',
    enterNow: 'Ingresar ahora',
    invalidMessage: 'Contraseña o email inválido',
    labels: {
      email: 'Email',
      password: 'Contraseña',
    },
    placeholders: {
      password: 'Contraseña',
    },
    successMessage: 'Autenticación exitosa',
  },
  recovery: {
    title: 'Recuperar contraseña',
  },
  signUp: {
    emailTitle: 'Crear su cuenta',
    emailDescription:
      'Vamos a configurarte todo. Primero, confirma la dirección de correo electrónico donde recibiste la notificación.',
    passwordTitle: 'Crea tu contraseña',
    passwordDescription: 'Require una contraseña que contenga: ',
    passwordDescriptionLeast: {
      minCharacters: '8 caracteres mínimo',
      uppercase: '1 mayúscula',
      lowercase: '1 minúscula',
      number: '1 número',
      special: '1 caracter especial',
    },
    placeholders: {
      email: 'Email',
      password: 'Password',
      acceptTerms: 'I accept the',
      terms: 'terms and conditions.',
    },
  },
  onBoarding: {
    title: 'Hacer Arribo único suyo',
    description:
      'Arribo funciona mejor cuando se ajusta a sus preferencias. Tome 2 minutos y disfrute una experiencia más relevante.',
    personalizeExperience: 'Personalizar experiencia',
    skipPersonalization: 'Saltar personalización',
  },
  verifyAccount: {
    title: 'Verificando ...',
  },
  rules: {
    required: 'El campo es requerido',
    email: 'Introduce un correo electrónico válido',
    number: 'Por favor ingrese un número valido',
    phoneInvalid: 'Número de teléfono no válido',
    phoneMin: 'El número de teléfono debe tener al menos 6 caracteres',
    phoneMax: 'El número de teléfono debe tener al menos 10 caracteres',
    decimal: 'El campo numérico debe tener 2 dígitos después del decimal o menos',
    max: 'El campo es no debe contener más de {max} caracteres',
    min: 'El campo es no debe contener al menos {min} caracteres',
    password:
      'Tu contraseña debe contener mínimo 8 caracteres, una mayúscula y un carácter especial',
    passwordMismatch: 'Las contraseñas no coinciden',
    names: 'Nombre inválido',
    documentId: 'Documento de identificación inválido',
  },
  personalize: {
    cityTitle: 'A dónde estás viajando?',
    cityDescription:
      'Nosotros prepararemos un guía de ciudad y recomendarémos recomendaciones relevantes para ti.',
    infoTitle: 'Cuéntanos sobre ti',
    infoDescription:
      'Nosotros prepararemos un guía de ciudad y recomendarémos recomendaciones relevantes para ti.',
    datesTitle: '¿Cuándo deseas reservar tu alojamiento?',
    datesDescription: 'Nosotros mostraremos recomendaciones relevantes para ti.',
    purposeTitle: '¿Por qué estás viajando?',
    purposeDescription:
      'Adaptaremos la experiencia a tu propósito de viaje para mantener todo relevante.',
    labels: {
      city: 'Ciudad',
      name: 'Nombre',
      lastname: 'Apellido',
      location: 'Ciudad de Origen',
      arrival: 'Llegada',
      departure: 'Salida',
      birthdate: 'Fecha de Nacimiento',
      purpose: {
        options: {
          student: 'Soy un estudiante',
          work: 'Viaje laboral',
          Leisure: 'Ocio',
          other: 'Otro',
        },
      },
    },
    placeholders: {
      city: 'Ciudad',
      name: 'Nombre',
      lastname: 'Apellido',
      location: 'Localización',
      arrival: 'Llegada',
      departure: 'Salida',
      birthdate: 'Fecha de cumpleaños',
    },
  },
  announcement: {
    payment: {
      monthly: 'Pago mensual',
      fortnightly: 'Pago quincenal',
      daily: 'Pago diario',
    },
    minPeriod: 'Mínimo de días permitido para reservar',
    days: 'Días',
    monthly: 'Mensual',
    fortnightly: 'Quincenal',
    daily: 'Diario',
    numBath: 'Baños',
    bathroom: 'Baño',
    kitchenIncluded: 'Cocina',
    yourOwnKitchen: 'La propiedad cuenta con una cocina adaptada a tus necesidades.',
    policy: {
      title: 'Política de cancelación',
      flexible: {
        1: 'Reembolso total hasta 30 días antes del check-in. Reembolso parcial (50% del coste de la reserva) entre 7 y 30 días antes del check-in. Los costes correspondientes a depósito, reserva, cuota de propietario no son reembolsables',
      },
      strict: {
        1: 'Sin reembolso',
      },
    },
    bedroom: 'Habitación',
    bedrooms: 'Habitaciones',
    photos: 'Fotos',
    videos: 'Videos',
    virtual: 'tour virtual',
    map: 'Mapa',
    location: 'Ubicación',
    thisIs: 'Este alojamiento es para',
    registry: 'Número de registro',
    roomIn: 'Habitación en una propiedad',
    yourOwn: 'Tu propia habitación en alojamiento, más acceso a espacios compartidos.',
    sharedSpaces: 'Espacios compartidos',
    youWill: 'Compartirás algunas zonas del alojamiento.',
    sharedBathroom: 'Baño compartido',
    youWillShare: 'Compartirás el baño con otras personas.',
    youWillStay: 'Te quedarás aquí',
    services: 'Servicios y gastos',
    viewAll: 'Ver todo',
    cancellation: 'Políticas de cancelación',
    totalArea: 'Superficie total',
    maxCap: 'Capacidad máxima',
    people: 'personas',
    rentalConditions: 'Condiciones de alquiler',
    contractModel: 'Modelo de contrato',
    season: 'Temporada',
    terms: 'Términos de pago y modelo de contrato',
    bookNow: 'Reservar',
    thisPlace: 'Este lugar ofrece',
    generalInformation: 'Información general',
    features: 'Características',
    furniture: 'Muebles',
    furnitures: 'Muebles',
    createAccount: 'Crear cuenta',
    unlockDetails: 'Desbloquear detalles y reserva',
    orLogin: 'o inicia sesión',
  },
  search: {
    loadMoreResults: 'Cargar más resultados',
    results: 'resultados',
    cantFind: '¿No puedes encontrar nada que te guste?',
    changeYour: 'Cambia tus preferencias',
    discover: 'Descubre dónde hospedarte',
    personalize: 'Personaliza tus recomendaciones',
    discoverDescription:
      'Donde sea que vayas, podemos ayudarte a encontrar un lugar para hospedarte que se ajuste a tus necesidades.',
    showRec: 'Mostrar recomendaciones',
    clearFilters: 'Eliminar filtros',
    applyPreferences: 'Aplicar preferencias',
    city: 'Ciudad',
    dateRange: 'Rango de fechas',
    arrival: 'Llegada',
    departure: 'Salida',
    accomType: 'Tipo de alojamiento',
    priceRange: 'Rango de precios',
    minPrice: 'Precio mínimo',
    maxPrice: 'Precio máximo',
  },
  profile: {
    documentTitle: 'Documentos',
    title: 'Perfil',
    showProfile: 'Completa tu perfil',
    joinDateWithYear: '{years} años y {days} días en Lodgerin',
    joinDate: '{days} días en Lodgerin',
    myProfileTitle: 'Datos Personales',
    editTitle: 'Editar perfil',
    editDescription: 'Información general',
    myAccountTitle: 'Mi cuenta',
    myAccountDescription: 'Aquí puedes cambiar tu contraseña y otros detalles.',
    contactData: 'Datos de contacto',
    moreAboutMe: 'Más sobre mi',
    createdOn: 'Creado en',
    latestUpdate: 'Última actualización',
    profileUpdatedSuccessfully: 'Perfil actualizado exitosamente.',
    myDocumentTitle: 'Documentos',
    myDocumentDetailTitle: '{type} detalle',
    personalData: 'Datos personales',
    myAccount: 'Mi cuenta',
    documents: 'Documentos de identificación',
    settings: 'Configuraciones',
    changePhotoProfile: 'Cambiar foto perfil',
    notPersonalData: 'No tienes datos personales para mostrar',
    areaCode: 'Código Area',
    enterCountryName: 'Ingresar nombre del país',
    nationalityTitle: 'Nacionalidad',
    nationalitySearch: 'Buscar nacionalidad',
    labels: {
      name: 'Nombre',
      lastName: 'Apellido',
      gender: 'Género',
      nationality: 'Nacionalidad',
      code: 'Código',
      phoneNumber: 'Teléfono',
      documentType: 'Tipo de documento',
      documentId: 'Documento identidad',
      id: 'ID',
      passport: 'Pasaporte',
      nif: 'NIF',
      nie: 'NIE',
      taxId: 'Documento de identidad de empresa',
      birthdate: 'Fecha de nacimiento',
      age: 'Edad',
      origin: 'Origen',
      numberId: 'Número de identificación',
      renewal: 'Seleccione fecha de renovación',
      expiration: 'Selecciona fecha de expiración',
      male: 'Masculino',
      female: 'Femenino',
      other: 'Otro',
      language: 'Idioma',
    },
    placeholders: {
      name: 'Nombre que aparece en tu documento de identidad',
      lastName: 'Apellidos que aparecen en tu documento de identidad',
      numberId: 'Número de documento',
      renewal: 'Seleccione fecha de renovación',
      expiration: 'Selecciona fecha de expiración',
    },
    email: {
      title: 'Email',
      description:
        'Por favor, ingresa la nueva dirección de correo electrónico a la que deseas cambiar. Asegúrate de proporcionar una dirección válida a la que tengas acceso.',
      descriptionCode:
        'Recibimos tu solicitud para cambiar la dirección de correo electrónico asociada con tu cuenta. Por favor, verifica tu bandeja de entrada y ingresa el código de verificación que se te ha enviado.',
      changeEmail: 'Cambiar email',
      emailPlaceholder: 'Nuevo email',
      enterCode: 'Ingresar código',
      codePlaceholder: 'Ingresar código',
      emailChangedSuccessfully: 'Email cambiado exitosamente.',
    },
    password: {
      title: 'Contraseña',
      description: 'Cambia tu contraseña.',
      changePassword: 'Cambiar contraseña',
      currentPassword: 'Actual contraseña',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      passwordChangedSuccessfully: 'Contraseña cambiada exitosamente.',
    },
    recovery: {
      title: 'Recuperación de contraseña',
      description: 'Ingrese su email para recuperar tu contraseña.',
      emailPlaceholder: 'Email',
    },
    photo: {
      photoChangedSuccessfully: 'Foto actualizada exitosamente.',
    },
    document: {
      detail: 'Detalle',
      edit: 'Editar',
      download: 'Descargar',
      rentalContract: 'Contrato de Renta',
      documentToSign: 'Documento para firmar',
      downloadContractSigned: 'Descargar documento firmado',
      signNow: 'Firmar ahora',
      signNowDescription:
        'Tu contrato de renta está listo para firmar! Asegúrate de firmarlo antes de check-in en la habitación.',
      pendingSignByOwner: 'Pendiente firma del propietario',
      Passport: 'Pasaporte',
      'ID Document': 'Documento de identidad personal',
      'Select Issue/renewal date': 'Fecha de expiración',
      'Rental Contract': 'Contrato de Renta',
      'Contrato de Renta': 'Contrato de Renta',
    },
    setting: {
      title: 'Idioma',
      description: 'Por favor, selecciona el idioma en el que deseas ver y editar tus datos.',
      languageUpdatedSuccessfully: 'Idioma cambiado exitosamente.',
      notifications: 'Notificaciones',
      notificationsDescription: 'Recibir notificaciones en la App',
    },
    account: {
      requestInProcess: 'Solicitud en progreso',
      deleteAccount: 'Eliminar cuenta',
      description: 'Solicitar la eliminación de la cuenta y todos sus datos',
      request: 'Solicitar eliminación',
      requestDescription:
        'Al procesar tu solicitud, tu información personal, incluyendo fotos y chats, se eliminará permanentemente de nuestra plataforma.',
      dateProgramed:
        'Tu solicitud de eliminación de cuenta está en proceso. La fecha programada para la eliminación es el',
      cancel:
        '. Puedes cancelar esta solicitud en cualquier momento antes de esa fecha volviendo a iniciar sesión en tu cuenta. Hasta entonces, tu información se conservará de forma segura.',
    },
  },
  files: {
    passport: 'Pasaporte',
    'id document': 'Identificación',
    upload: 'Subir {title}',
    'Add document image': 'Subir imagen del documento',
    'Add images': 'Subir imagen',
    'Browse file': 'Buscar archivo {type}',
    browseImage: 'Buscar image {type}',
    gallery: 'Subir una imagen desde la galería',
    photo: 'Tomar una foto',
    fileDescription:
      'El archivo debe ser en formato  JPEG, JPG, PNG or PDF y tener un tamaño máximo de 5MB.',
    expires: {
      expiresMoreTwelveMonths: 'Expira en más de 12 meses',
      expiresMoreSixMonths: 'Expira entre 6 y 12 meses',
      expiresMoreThreeMonths: 'Expira entre 3 y meses',
      expiresLessThreeMonths: 'Expira en menos de tres meses',
      expired: 'Documento expirado',
      numberId: 'Número de identificación',
      renewal: 'Fecha renovación',
      expiration: 'Fecha expiración',
      lastUpdated: 'Última actualización',
      expirationStatus: 'Estado de la expiración',
    },
    signContractManualDescription:
      'Descarga el contrato de renta y firma manualmente. Escanea el archivo y súbelo como PDF, asegúrate de que el peso del archivo sea menor a 5MB.',
    browseFile: 'Seleccionar el archivo',
    uploadDocument: 'Subir documento',
    replaceNow: 'Reemplazar ahora',
    status: {
      verificationStatus: 'Estado de verificación',
      pending: 'Pendiente',
      rejected: 'Rechazado',
      signedByOwner: 'Firmado por el propietario',
      verified: 'Verificado',
      pendingAcceptanceOrReview: 'Pendiente de aceptación o revisión',
      not_validated: 'No validado',
      validated: 'Validado',
    },
  },
  invoices: {
    download: 'Descargar',
    payNow: 'Pagar ahora',
    paymentsAnd: 'Pagos y facturas',
    invoice: 'Factura',
    billingDetails: 'Detalles de facturación',
    name: 'Nombre',
    billingAddress: 'Dirección de facturación',
    email: 'Correo electrónico',
    issueDate: 'Fecha de emisión',
    paidOn: 'Pagado el',
    paymentDeadline: 'Fecha límite de pago',
    status: 'Estado',
    invoiceList: 'Lista de facturas',
    subtotal: 'Subtotal',
    total: 'Total',
    to: 'Para',
    from: 'De',
  },
  status: {
    pending: 'Pendiente',
    accepted: 'Aceptado',
    paid: 'Pagado',
    canceled: 'Cancelado',
    sent: 'Pendiente',
  },
  tabs: {
    guides: 'Guías',
    myStay: 'Mi estancia',
    explore: 'Explorar',
    support: 'Soporte',
    perks: 'Beneficios'
  },
  documents: {
    addId: 'Añadir documento de identificación',
    selectType: 'Selecciona un tipo de documento de identificación para cargar',
    addIdOn: 'Agregar ID',
    idDocument: 'Documento de identificación',
    description:
      'Selecciona un documento de identificación cargado o añade uno nuevo. Mejora tu perfil generando confianza en los propietarios de alojamiento',
  },

  booking: {
    bookingData: 'Datos de la reserva',
    host: 'Anfitrión',
    rent: 'Alquiler',
    days: 'Días',
    people: 'Personas',
    billing: {
      commercial: 'Nombre comercial',
      title: 'Datos de facturación',
      billingSubject: {
        people: 'Desplazado',
        entity: 'Empresa',
      },
      description:
        'Selecciona el sujeto de facturación. Usaremos esta información para tus futuras facturas',
      complete: 'Completa con los datos de tu perfil',
      name: 'Nombre',
      idType: 'Tipo de ID',
      documentId: 'Número de identificación',
      email: 'Correo electrónico',
    },
    editDates: {
      title: 'Editar fechas de reserva',
      btn: 'Guardar cambios de fecha',
      description:
        'Al editar las fechas de la reserva, debemos verificar que el alojamiento estará disponible en el nuevo periodo de estancia. Si no hay disponibilidad, tendrás que seleccionar otro alojamiento.',
    },
    verify: {
      title: 'Verifica tus datos de reserva',
      description:
        'Selecciona los servicios que quieres añadir a tu reserva. Estos valores se añadirán al precio de alquiler acordado',
      costSummary: 'Resumen de costos',
      upfront: 'Costos iniciales',
      reservationValue: 'Valor de la reserva',
      deposit: 'Valor del depósito',
      fixed: 'Costos fijos',
      rent: 'Precio de alquiler',
      taxes: 'Impuestos',
      confirm: 'Confirmar reserva',
    },
    services: 'Servicios adicionales',
    servicesDescription:
      'Selecciona los servicios que deseas añadir a tu reserva. Estos valores se añadirán al precio de alquiler acordado',
    documents: {
      title: 'Documentos',
      description: 'Completar y revisar su información personal',
    },
    botonChat: {
      title: 'Chatear con el anfitrión', //Agregamos título botonChat
    },
  },
  gender: {
    female: 'Mujer',
    Male: 'Hombre',
  },
  bookingDetails: {
    weDidntFind: 'Ups! no encontramos ninguna propiedad disponible',
    makeChanges: 'Haz cambios en tu reservación para encontrar la propiedad ideal para ti',
    myBooking: 'Mi estancia',
    title: 'Detalles de reserva',
    myPage: 'Mi estancia',
    hoursRemain: 'El propietario te responderá en un máximo de {hours}hs',
    datesOf: 'Días de estancia',
    rejectingReason: 'Razón de rechazo: {reason}',
    ohNo: 'Oh no! Tu reservación ha sido rechazada',
    someSuggestions:
      'De todas maneras, hemos preparado algunas sugerencias que podrían coincidir con tu última búsqueda',
    pendingPayment:
      'Tienes una factura pendiente de pago. Recuerda pagar en las siguientes 48 horas',
    notBooking: 'No tienes reservas en este momento',
    notBookingDescription:
      'Dondequiera que vayas, podemos ayudarte a encontrar un lugar para quedarte que se ajuste a tus necesidades.',
    myStay: 'Mi Estancia',
    nextAccommodation: 'Tu próxima estancia',
    cancelledAccommodation: 'Tu reserva ha sido cancelada',
    showBookingDetails: 'Ver detalles de la reserva',
    previousAccommodation: 'Tus estancia previas',
    invoiceMessage1: 'Tu reservación ha sido aceptada.',
    invoiceMessageBold: 'Tienes 48 horas para pagar la primera renta del mes o el depósito, ',
    invoiceMessage2: 'como está estipulado en tu contrato. Revisa tu perfil para más detalles.',
  },
  cancelledReasonsItems: {
    temp: 'Temporalmente no disponible debido a renovación',
    prev: 'Prórroga de reserva del inquilino anterior',
    ten: 'El inquilino no cumplió con los requisitos',
    rate: 'La tarifa no cumple con las condiciones acordadas',
    stay: 'El período de estancia es menor al mínimo establecido',
    acco: 'El alojamiento está reservado en ese período de tiempo',
    dep: 'El depósito no es suficiente o no fue encontrado',
    meet: 'El inquilino no ha cumplido con los requisitos de depósito o garantía estipulados para confirmar la reserva',
    unna: 'Políticas de cancelación inaceptables',
    canc: 'Las políticas de cancelación del inquilino no coinciden con el acuerdo de alojamiento',
    owner: 'Las políticas del propietario han cambiado',
    book: 'Las actualizaciones de términos de reserva no coinciden con la solicitud del inquilino',
    error: 'Error en la disponibilidad de la propiedad',
    prop: 'Falló la sincronización de la disponibilidad de la propiedad',
    noReason: 'No se proporcionó razón',
  },
  property: {
    titleDetail: 'Detalle del alojamiento',
    availableAccommodations: 'Habitaciones disponibles en este alojamiento',
  },
  filters: {
    location: 'Ubicación',
    filters: 'Filtros',
    accommodations: 'Alojamientos',
    allProperties: 'Todos',
  },
  'check-in': {
    welcome: 'Bienvenido',
    description:
      'Estamos encantados de hospedar su estancia. Revisaremos las características de su alojamiento en dos pasos principales:',
    stepOne: '1. Aspectos generales del alojamiento',
    stepTwo: '2. Revisión de los espacios de la propiedad',
    startCheck: 'Iniciar Check-in',
    generalAspects: 'Aspectos generales',
    spacesReview: 'Revisión de espacios',
    youHaveFinished: '¡Ha terminado los aspectos generales del alojamiento!',
    continueSpaces: 'Continuemos con la revisión de cada espacio de la propiedad',
    startSpaces: 'Iniciar revisión de espacios',
    suggestions: '¿Tiene alguna sugerencia para el propietario?',
    suggestionsText: 'Por favor, háganos saber cómo podemos mejorar su estancia dejando un mensaje',
    writeComment: 'Escribe un comentario',
    skipThis: 'Saltar este paso',
    yes: 'Si',
    goToArribo: 'Ir a la App Arribo',
    youHaveFinishedCheck: '¡Finalizaste tu Check-in!',
    finishDescription: 'Vuelve a la App y disfruta tu estadía',
    report: 'Reportar incidente',
    reportDescription: 'Describe tu desacuerdo y sube imágenes para dar soporte al reporte',
    createReport: 'Crear reporte',
    reportSaved: 'Reporte guardado!',
    card: 'El proceso de check-in está activo. Puedes completarlo en las siguientes 48 horas',
    cardBtn: 'Comenzar check-in',
  },
  'check-out': {
    welcome: '¡Hola,',
    description:
      'Esperamos que su estancia haya sido placentera. Revisaremos las características de su alojamiento en dos pasos principales antes de su salida:',
    stepOne: '1. Aspectos generales del alojamiento',
    stepTwo: '2. Revisión de los espacios de la propiedad',
    startCheck: 'Comenzar el check-out',
    generalAspects: 'Aspectos generales',
    spacesReview: 'Revisión de espacios',
    youHaveFinished: '¡Has terminado los aspectos generales del alojamiento!',
    continueSpaces: 'Continuemos con la revisión de cada espacio de la propiedad',
    startSpaces: 'Comenzar la revisión de espacios',
    suggestions: '¿Tienes sugerencias para el propietario?',
    suggestionsText: 'Por favor, háganos saber cómo podemos mejorar su estancia dejando un mensaje',
    writeComment: 'Escribir un comentario',
    skipThis: 'Omitir este paso',
    yes: 'Sí',
    goToArribo: 'Finalizar mi estancia',
    youHaveFinishedCheck: '¡Has terminado tu check-out!',
    finishDescription:
      'Tu viaje ha terinado ahora. Esperamos poder ayudarte en tu próxima aventura',

    report: 'Reportar incidente',
    reportDescription: 'Describe tu desacuerdo y sube imágenes para respaldar tu informe',
    createReport: 'Crear informe',
    reportSaved: '¡Informe guardado!',
    card: 'Tu proceso de check-out ya está disponible.',
    cardBtn: 'Iniciar check-out',
    evaluator: {
      description: 'Rellena el formulario para comenzar el proceso como invitado',
      firstStep: 'Vamos a revisar los muebles del alojamiento en dos pasos principales:',
    },
  },
  post: {
    in: 'en',
    at: 'el',
    guides: 'Guías y artículos',
  },
  shepperdTour: {
    modalText: 'Para poder reservar, tienes que echarle un vistazo a los alojamientos disponibles',
    finishButton: '¡Entendido!',
  },
  support: {
    sentByAdmin: 'Enviado por administrador',
    online: 'En línea',
    notAvailable: 'Este chat no está disponible',
    chat: {
      start: 'Comenzar conversación',
      writeMessage: 'Escribe un mensaje',
      searchEmoji: 'Buscar Emoji',
      skinTone: 'Tono de piel',
    },
    owner: {
      titleCard: 'Habla con el propietario de tu alojamiento',
    },
    agent: {
      titleCard: 'Asistente de reservas',
      descriptionCard:
        '¿Necesitas ayuda? ¡Conversa con nuestro robot de soporte para respuestas rápidas!',
      titleCard2: 'Genera un incidente', //Agregamos título Card2
      descriptionCard2: '¿Tiene usted un problema que necesita resolverse rápidamente?',//Agregamos descripción Card2
      modalTitle: "Informar incidente", //Agregamos título modal
      modalDescription: "Describe tu desacuerdo y carga imágenes para respaldar tu problema.", //Agregamos Descripción modal
      addImages: "Añadir imágenes", //Agregamos boton imagenes
      incidentTitle: "Título del incidente", //Agregamos título incidente
      incidentPlaceholder: "Daño en la lavadora", //Agregamos Placeholder
      requiredField: "Este campo es obligatorio", //Agregamos texto requerido
      invalidFormat: "Por favor, escribe un texto más descriptivo (mín. 6 caracteres, sin símbolos extraños)", //Agregamos texto validación
      invalidTitle: "Por favor, escribe un título más descriptivo", //Agregamos texto validación título
      invalidMeaning: "Por favor, escribe un comentario que tenga sentido", //Agregamos texto validación comentario
      validationError: "Por favor completa todos los campos obligatorios correctamente", //Agregamos texto error validación modal
      incidentReported: "Su incidente ha sido reportado exitosamente", //Agregamos texto reportado validación modal
      writeComment: "Escribe un comentario", //Agregamos título comentario
      commentPlaceholder: "La lavadora no funciona, al encenderla aparece un error y no lava.", //Agregamos Placeholder
      urgency: "¿La incidencia es de alta urgencia? (opcional)", //Agregamos título urgencia
      urgencyYes: "Sí, es urgente", //Desplegable opción Sí
      urgencyNo: "No, puede esperar", //Desplegable opción No
      noReservation: "No se puede crear un incidente sin una reserva activa", // Agregamos mensaje si no hay reserva
      closeButton: "Cancelar", //Agregamos Boton de Cancelar
      createReport: "Crear reporte", //Agregamos Boton de Crear reporte
    },
    incident: {
      title: 'Historial de incidentes', //Agregamos título
      filter: 'Filtros', //Agregamos título botón
      noIncidents: 'No se encontraron incidentes', //Agregamos no se encontraron incidentes
      invalidDate: 'Fecha no disponible', //Agregamos fecha no disponible
      noDescription: 'Sin descripción disponible', //Agregamos texto sin descripción disponible
      reported: "Reportada", //Agregamos estado reportada
      solved: "Resuelta", //Agregamos estado resuelta
      notAttended: "No atendida", //Agregamos estado no atendida
      referenceCode: 'Alojamiento', //Agregamos referencia RU
      descriptionCard: '¿Necesitas ayuda? Conversa con nosotros — ¡Estamos felices de ayudarte!',
    },
    faqs: {
      title: 'Preguntas frecuentes',
      question1: '¿Cómo puedo actualizar mis datos personales?',
      answer1:
        'Haz clic en el icono circular azul ubicado en la parte superior derecha. Esto te llevará a la pantalla de tu perfil, desde donde podrás modificar toda tu información personal, incluyendo tu contraseña e idioma.',
      question2: '¿Es obligatorio que suba mi documento de identidad o pasaporte?',
      answer2: 'Si, para hacer una reserva es obligatorio confirmar que tus datos son correctos.',
      question3: '¿Puedo eliminar mi cuenta?',
      answer3:
        'Si, pinchando en el icono circular azul ubicado en la parte superior derecha, seleccionas el apartado de configuración y en la parte de abajo podrás eliminar tu cuenta. Para recuperarla, simplemente deberás iniciar sesión de nuevo con tus datos y volverás a tener tu cuenta de Arribo activa con toda la información guardada anteriormente.',
      question4: '¿Cómo puedo ver los términos y condiciones?',
      answer4:
        'Al darte de alta, cuando aceptas los términos y condiciones, si pinchas en el link azul, te llevará a la página donde podrás leerlos.',
      question5: '¿Cuál es la estancia mínima para un alojamiento?',
      answer5:
        'El período mínimo de estancia para el alojamiento es decidido directamente por el propietario. Cuando consultes los detalles del alojamiento en las "condiciones de alquiler", podrás ver la cantidad exacta de tiempo requerido. De igual manera, en las “notas” del alojamiento podrás ver información adicional acerca de éste aspecto.',
      question6: '¿Cómo hago una reserva?',
      answer6:
        'Busca y selecciona el alojamiento que más se ajuste a tu búsqueda con los filtros que aparecen en la parte de arriba. Una vez dentro, selecciona la habitación que quieras reservar y pincha en el icono azul de reservar que aparece en la parte de abajo a la derecha. Completa los datos solicitados y las fechas de tu estancia y confirma la reserva. El propietario te responderá en un plazo máximo de 48 horas.',
      question7: '¿Cómo veo mis reservas pendientes?',
      answer7:
        'En la página principal, en la parte de abajo de la derecha, pincha en el icono de "mi estancia" y te llevará a la página de tus estancias.',
      question8: '¿Puedo hacer varias reservas aunque sean en alojamiento y fechas diferentes?',
      answer8:
        'No, hasta que no tengas una reserva confirmada no podrás hacer otra nueva reserva aunque sea en un alojamiento y en fechas distintas.',
      question9: '¿Puedo ver el alojamiento antes de mudarme?',
      answer9:
        'No organizamos visitas físicas ni virtuales. Nuestro proceso de reserva es 100% online, pero no te preocupes, todas nuestras propiedades son verificadas por nuestro departamento de operaciones.',
      question10: '¿Cómo puedo ver la cantidad que voy a pagar cuando confirmen mi reserva?',
      answer10:
        'Al hacer la petición de reserva, en la segunda pantalla, donde introduces los datos de tu reserva, verás el resumen de la cantidad a pagar y si pinchas en el triángulo de la derecha, se abre un desplegable con el desglose de los importes.',
      question11: '¿Cómo contacto con el propietario? ',
      answer11:
        'Una vez realizada y aceptada tu solicitud de reserva, te aparecerán los datos de contacto del propietario en la parte de abajo a la derecha, haciendo click en la sección de "soporte" y pinchando en "habla con el propietario de tu alojamiento". Además, tendrás acceso también a las dudas frecuentes por si tu duda estuviera entre ellas.',
      question12: '¿Qué cantidad voy a pagar cuando haga mi solicitud de reserva?',
      answer12:
        'No tendrás que pagar nada al hacer la solicitud de tu reserva. Una vez aceptada por el propietario, deberás abonar el importe estipulado en la misma en un plazo de 48 horas. ',
    },
  },
  relocatedHome: {
    choose: 'Ahora puedes elegir tu alojamiento',
    explore: 'Explorar',
    prepare: 'Prepara tu viaje',
    checklist: 'Esta lista de verificación te ayudará a tener todo listo para tu viaje',
    verify: 'Verifica tu identidad',
    complete: 'Completa los datos de facturación',
    communicateGroup: 'Comunícate con el representante del grupo instantáneamente',
  },
  onBoardingRelocated: {
    arriboIs: '¡Arribo es absolutamente tuyo!',
    prepared: 'preparó un perfil previo con todos los aspectos de tu viaje.',
    however:
      'Sin embargo, por favor ayúdanos a brindarte el mejor servicio revisando y confirmando tu información.',
    review: 'Revisa ahora',
    remind: 'Recuérdame más tarde',
  },
  perks: {
    locationHint: {
      title: 'Activa tu ubicación',
      description: 'Obtén una mejor experiencia descubriendo eventos cercanos a ti.',
    },
    emptyTitle: 'Explora otros eventos',
    emptySubtitle: 'No hay eventos programados para las fechas y destino seleccionados.',
    availableEvents: 'Eventos disponibles',
    noResults: 'No se encontraron resultados',
    results: 'resultados',
    loadingEvents: 'Cargando eventos...',
    detail: {
      title: 'Detalle del evento',
      loading: 'Cargando evento...',
      descriptionPlaceholder: 'Este evento no tiene una descripción disponible.',
      location: 'Ubicación',
      dateTime: 'Fecha y hora',
      similar: 'Eventos similares',
      bookNow: 'Reservar ahora',
      whatsIncluded: 'Qué incluye',
      photos: 'Fotos'
    },
    fromPrice: 'Desde',
    status: {
      available: 'Disponible',
      limited: 'Disponibilidad limitada',
      soldout: 'Agotado',
    },
    searchPlaceholder: 'Buscar eventos, ubicaciones...',
    category: {
      essentials: 'Esenciales',
      entertainment: 'Entretenimiento',
      seasonal: 'Eventos de temporada',
      food: 'Comida y Bebida',
      city: 'Tours por la ciudad',
    },
    filters: {
      today: 'Hoy',
      thisWeekend: 'Este finde',
      nextWeek: 'Próxima semana',
    },
  },
  additionalCosts: {
    bookingPrice: {
      title: 'Tarifa del propietario',
      description: 'Tarifa cargada al propietario para administración de la propiedad',
    },
    deposit: {
      title: 'Depósito',
      description: 'Monto de garantía',
    },
    description: 'Estos son los montos que tendrás que pagar una vez tu reserva sea aceptada.',
    title: 'Costos adicionales',
    costsAndServices: 'Costos y servicios',
    gasFee: 'Gas',
    internetFee: 'Wi-Fi',
    waterFee: 'Agua',
    cleaningFee: 'Limpieza',
    electricityFee: 'Electricidad',
    included: 'Incluido',
    notIncluded: 'No incluido',
  },
  maintenance: {
    title: 'Estamos haciendo mejoras',
    descriptionLine1: 'Actualmente estamos realizando mejoras y mantenimiento en la aplicación.',
    descriptionLine2: 'Por favor, intenta nuevamente en unos minutos.'
  },
    questionnaire: {
    title: '¡Gracias por llegar hasta aquí!',
    submit: 'Enviar',
    skip: 'Omitir paso',
    modal: {
      title: '¿Podrías decirnos cuál? (opcional)',
      placeholder: '¿Quién te refirió?',
      back: 'Atrás',
      submit: 'Enviar'
    }
  }
};
